export default __webpack_public_path__ + "static/min-duration-light-mode-d80cd631b5db3eb749b7b7c5ea3cc125.png";